module.exports = __webpack_public_path__ + "static/media/sync.636a4562.svg";